/** Shared page-size presets for list UIs (inventory, transactions, catalog search, etc.). */
export const LIST_PAGE_SIZE_OPTIONS = [25, 50, 100, 200] as const

/** QR generator paginates its codes grid independently of standard list pages. */
export const QR_LABEL_GRID_PAGE_SIZE_OPTIONS = [24, 48, 96] as const
